module.exports = __webpack_public_path__ + "static/media/vasikka.be642b00.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./media/photos/vasikka.jpg
 ** module id = 437
 ** module chunks = 0
 **/